import React from 'react'
import { useNavigate } from 'react-router-dom'

interface FormActionsProps {
  isEditing: boolean
  loading: boolean
}

const FormActions: React.FC<FormActionsProps> = ({ isEditing, loading }) => {
  const navigate = useNavigate()

  return (
    <div className='d-flex flex-column flex-md-row justify-content-between mt-4'>
      <button
        type='button'
        className='btn btn-secondary mb-3 mb-md-0'
        onClick={() => navigate('/blog')}
      >
        Anuluj
      </button>

      <button
        type='submit'
        className='btn btn-primary'
        disabled={loading}
      >
        {loading
          ? (
            <>
              <span className='spinner-border spinner-border-sm me-2' role='status' aria-hidden='true' />
              Zapisywanie...
            </>
            )
          : isEditing ? 'Aktualizuj artykuł' : 'Dodaj artykuł'}
      </button>
    </div>
  )
}

export default FormActions
